!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.kea = t());
}(this, function () {
  "use strict";

  return [{
    locale: "kea",
    pluralRuleFunction: function (e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "Anu",
        relative: {
          0: "es anu li",
          1: "prósimu anu",
          "-1": "anu pasadu"
        },
        relativeTime: {
          future: {
            other: "di li {0} anu"
          },
          past: {
            other: "a ten {0} anu"
          }
        }
      },
      "year-short": {
        displayName: "anu",
        relative: {
          0: "es anu li",
          1: "prósimu anu",
          "-1": "anu pasadu"
        },
        relativeTime: {
          future: {
            other: "di li {0} anu"
          },
          past: {
            other: "a ten {0} anu"
          }
        }
      },
      month: {
        displayName: "Mes",
        relative: {
          0: "es mes li",
          1: "prósimu mes",
          "-1": "mes pasadu"
        },
        relativeTime: {
          future: {
            other: "di li {0} mes"
          },
          past: {
            other: "a ten {0} mes"
          }
        }
      },
      "month-short": {
        displayName: "mes",
        relative: {
          0: "es mes li",
          1: "prósimu mes",
          "-1": "mes pasadu"
        },
        relativeTime: {
          future: {
            other: "di li {0} mes"
          },
          past: {
            other: "a ten {0} mes"
          }
        }
      },
      day: {
        displayName: "Dia",
        relative: {
          0: "oji",
          1: "manha",
          "-1": "onti"
        },
        relativeTime: {
          future: {
            other: "di li {0} dia"
          },
          past: {
            other: "a ten {0} dia"
          }
        }
      },
      "day-short": {
        displayName: "dia",
        relative: {
          0: "oji",
          1: "manha",
          "-1": "onti"
        },
        relativeTime: {
          future: {
            other: "di li {0} dia"
          },
          past: {
            other: "a ten {0} dia"
          }
        }
      },
      hour: {
        displayName: "Ora",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "di li {0} ora"
          },
          past: {
            other: "a ten {0} ora"
          }
        }
      },
      "hour-short": {
        displayName: "ora",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "di li {0} ora"
          },
          past: {
            other: "a ten {0} ora"
          }
        }
      },
      minute: {
        displayName: "Minutu",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "di li {0} minutu"
          },
          past: {
            other: "a ten {0} minutu"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "di li {0} min"
          },
          past: {
            other: "a ten {0} min"
          }
        }
      },
      second: {
        displayName: "Sigundu",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "di li {0} sigundu"
          },
          past: {
            other: "a ten {0} sigundu"
          }
        }
      },
      "second-short": {
        displayName: "sig",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "di li {0} sig"
          },
          past: {
            other: "a ten {0} sig"
          }
        }
      }
    }
  }];
});